import * as types from '../../types';

export const newVersionIsAvailable = () => ({ type: types.NEW_APP_VERSION_IS_AVAILABLE });
export const newVersionIsActivated = () => ({ type: types.NEW_APP_VERSION_IS_ACTIVATED });
